<template>
  <router-link v-if="product.slug || isProviders" :to="productView">
    <el-card
      :body-style="bodyStyle"
      shadow="never"
      :style="{ opacity: available ? '1' : '1' }"
    >
      <el-row>
        <el-col
          :class="[
            isCarousel
              ? 'carousel__width carousel__height'
              : 'thumbnail__dimension',
            'image-container',
          ]"
        >
          <!-- style="width: 100% !important;" -->
          <div class="product-background">
            <div
              style="position: absolute; right: 10px; top: 6px"
              class="disponible-label"
            >
              <div class="flex">
                <div
                  :class="[
                    available ? 'couleur-disponible' : 'couleur-non-disponible',
                  ]"
                />
                <div class="label ml-5 product-availability-label">
                  {{
                      available
                        ? availableLabel
                        : disponibilite != ""
                        ? disponibilite
                        : notAvailableLabel
                    }}
                </div>
              </div>
            </div>
            <img
              :class="[
                isCarousel
                  ? 'carousel__width carousel__height'
                  : 'thumbnail__dimension',
              ]"
              :src="thumbnail"
              :fit="'contain'"
            />
          </div>
          <div v-if="countryCode == 'QC'" :class="inventoryClass" class="inventory-circle">
            <span v-if="inventory && getRoute !== 'STORE_MTL' && inventoryLabel()"
              class="inventory__label inventory"
            >
              {{ inventoryLabel() }}
            </span>
            <div
              class="circle circle--position-display"
              :style="{ background: pastilleColor }"
            />
          </div>
        </el-col>
      </el-row>

      <el-row>
        <el-col class="product__detail">
          <div class="highlight" v-if="releaseYear !== ''">
            {{ releaseYear }}
          </div>
          <div class="highlight" v-else>
            {{ commingDate }}
          </div>
          <div class="h5 product__name mt-4">
            {{ productName }}
          </div>
          <div class="subtitle2 producer_name mt-4">
            {{ provider }}
          </div>
          <div class="subtitle2 origin__detail">
            {{ origin }}
          </div>
          <div style="display: flex; justify-content: space-between; margin-top: 20px">
            <span class="paragraph2 product__volume">{{ volume }}</span>
            <span class="paragraph2 product__price" v-html="price"></span>
          </div>
        </el-col>
      </el-row>
    </el-card>
  </router-link>
</template>

<script>
import { mapState } from "vuex";
import { filter, get, head, isEmpty } from "@/utils/lodash";
import { formatCurrency, specialFormatCurrency } from "@/utils/common-utils";

import imgProductDefault from "@/assets/images/product/product-default.png";
import imgProductInventoryIp from "@/assets/images/product/product-inventory-ip.png";
import imgProductInventorySaq from "@/assets/images/product/product-inventory-saq.png";
import cssVariables from "@/assets/variables.scss";
import getRandomInt from "../../../mixins/getRandomInt";
import { resolveProductCardVintage } from "@/utils/product-vintage-utils";
export default {
  mixins: [getRandomInt],
  props: {
    product: {
      type: Object,
      default: () => {},
    },
    taxCode: {
      type: String,
      default: "IN",
    },
    isCarousel: {
      type: Boolean,
      default: false,
    },
    productType: {
      type: String,
      default: null,
    },
    isProviders: {
      type: Boolean,
      default: false,
    },
    backBtnName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      bodyStyle: {
        padding: "0px",
      },
      images: {
        productDefault: {
          src: imgProductDefault,
        },
        productInventoryIp: {
          src: imgProductInventoryIp,
        },
        productInventorySaq: {
          src: imgProductInventorySaq,
        },
      },
      inventoryType: null,
      constants: {
        PRODUCT_COLOR: "PRODUCT_COLOR",
        WHITE: "WHITE",
        PALE_ORANGE: "PALE_ORANGE",
        ORANGE: "ORANGE",
        RAMATO: "RAMATO",
        PINK: "PINK",
        PALE_RED: "PALE_RED",
        RED: "RED",
        COLORLESS: "COLORLESS",
        AMBER: "AMBER",
        BLACK: "BLACK",
      },
      countryCode: localStorage.getItem("countryCode") || "QC",
      inventoryClass: "quebec",
    };
  },
  computed: {
    ...mapState("configuration", ["actionBar"]),
    getRoute() {
      return this.$route.query?.inventory;
    },
    productView() {
      let resultPuid = null;
      if (this.$route.name === 'provider' || this.$route.name === 'globalSearch') {
        if (Array.isArray(this.product.productInventories) && this.product.productInventories.length) {
          // `$route.query.type` is the PRODUCT TYPE filter, never a market code,
          // so this always fell through to 'QC' and linked every card to the
          // Quebec variant. On the Ontario site the carousel therefore showed an
          // ON price but opened the QC sheet, and adding that to the cart pushed
          // a Quebec puid into an Ontario order.
          const countryCode =
            (this.actionBar && this.actionBar.country) ||
            localStorage.getItem("countryCode") ||
            "QC";
          // Deliberate preference order per market (consignment first on ON),
          // so keep these explicit rather than reusing getDefaultAvailability().
          const order = countryCode == 'QC' ? ['IP', 'SAQ', 'Brouhh', 'MERCH_MTL', 'BERGEVILLE'] : ['PI', 'LCBO', 'MERCH_TORONTO'];
          for (let code of order) {
            for (let prod of this.product.productInventories) {
              if (prod.inventory && prod.inventory.code === code) {
                resultPuid = prod.puid;
                break;
              }
            }
            if (resultPuid) {
              break;
            }
          }
        } else {
          resultPuid = get(this.product, "puid");
        }
      }
      
      return {
        name: "product",
        params: {
          slug: get(this.product, "slug", ""),
          productType: this.productType,
          backBtnName: this.backBtnName,
        },
        query: {
          id: this.$route.name === 'provider' || this.$route.name === 'globalSearch' ? resultPuid :
          get(this.product, "puid") && (this.productType != "" && this.productType != null)
              ? get(this.product, "puid")
              : get(this.product, "puid"),
          productType:
            get(this.product, "puid") && this.productType != ""
              ? this.productType
              : undefined,
          pid: get(this.product, "id")
        },
      };
    },
    origin() {
      const originHead = head(get(this.product, "origins"));
      const country = get(originHead, "country.name");
      const region = get(originHead, "region.name");

      return originHead && ` ${region == null ? "" : region}, ${country}`;
    },
    productName() {
      return get(this.product, "name");
    },
    provider() {
      const aliasName = get(this.product, "cmsProvider.name");

      if (aliasName == null) {
        return get(this.product, "provider.usualName");
      }
      return aliasName;
    },
    releaseYear() {
      if (this.product == null) return "";
      const releaseYear = resolveProductCardVintage(this.product);
      return releaseYear === "NM" ? "" : releaseYear;
    },
    price() {
      let price = get(this.product, "erpProduct.pricing.price", get(this.product, "pricing.price", 0));
      let agencyFees = get(this.product, "erpProduct.pricing.agencyFee", get(this.product, "pricing.agencyFee", 0));
      if (this.taxCode === "IN") {
        price = get(this.product, "erpProduct.pricing.priceTaxIn", get(this.product, "pricing.priceTaxIn", 0));
        if (price === 0 || price == null)
          price = get(this.product, "erpProduct.pricing.price", get(this.product, "pricing.price", 0));
        agencyFees = get(this.product, "erpProduct.pricing.agencyFeeWTaxes", get(this.product, "pricing.agencyFeeWTaxes", 0));
      }

      if (price + agencyFees === 0) {
        return "";
      }
      if (this.$i18n.locale == "fr-CA" || this.$i18n.locale == "en-US") {
        var formatPrice = specialFormatCurrency(
          price + agencyFees,
          this.$i18n.locale
        );
        if (this.$i18n.locale == "en-US") {
          formatPrice = formatPrice.split(".");
        } else {
          formatPrice = formatPrice.split(",");
        }

        if (formatPrice.length == 1) {
          formatPrice.push("00");
        }
        return `${
          formatPrice[0]
        }<sup style="font-size: 10px; line-height: 2; vertical-align: 5px;"> ${formatPrice[1]
          .toString()
          .padEnd(2, "0")}</sup> $`;
      }
      return `${formatCurrency(price + agencyFees, this.$i18n.locale)}`;
    },
    volume() {
      let volume = get(this.product, "volume", 0);
      let format = get(this.product, "format", 1);
      if (volume) {
        format = format == 1 ? "ml" : "l";
        volume = `${volume} ${format}`;
      } else {
        volume = "";
      }
      return get(this.product, "lblFormat");
    },
    thumbnail() {
      const thumbnail = get(this.product, "image.thumbnailLink");

      if (thumbnail == null) {
        return this.images.productDefault.src;
      }

      return thumbnail;
    },
    inventory() {
      if (this.inventoryType === "IP") {
        return this.images.productInventoryIp.src;
      }
      if (this.inventoryType === "SAQ") {
        return this.images.productInventorySaq.src;
      }

      return null;
    },
    pastilleColor() {
      return this.getPastilleColor(this.getColorCode());
    },
    available() {
      if(get(this.product, "erpProduct.quantity.inStock")){
        return get(this.product, "erpProduct.quantity.inStock")
      }
      return get(this.product, "quantity.inStock");
    },
    availableLabel() {
      return this.$i18n.t("products.productListView.label.available");
    },
    notAvailableLabel() {
      return this.$i18n.t("products.productListView.label.notAvailable");
    },
    disponibilite() {
      let nextBatches = get(this.product, "erpProduct.itemToCome", "");
      if (isEmpty(nextBatches)) {
        nextBatches = get(this.product, "itemToCome", "");
      }
      if (isEmpty(nextBatches)) {
        return "";
      }
      if (nextBatches.receptionPlanningDate) {
        var date1 = new Date(nextBatches.receptionPlanningDate);
        const month = date1.toLocaleString(this.$i18n.locale, {
          month: "short",
        });
        return `${month.toUpperCase().substring(0, 3)} ${date1
          .getFullYear()
          .toString()
          .slice(-2)}`;
      }
      return "";
    },
    commingDate() {
      let nextBatches = get(this.product, "erpProduct.itemToCome", "");
      if (isEmpty(nextBatches)) {
        nextBatches = get(this.product, "itemToCome", "");
      }
      if (isEmpty(nextBatches)) {
        return "";
      }
      if (nextBatches.receptionPlanningDate) {
        var date1 = new Date(nextBatches.receptionPlanningDate);
        return `${date1.getFullYear().toString()}`;
      }
      return "";
    },
  },
  watch: {
    // Watch for changes in the product or country code
    product: {
      handler() {
        this.inventoryType = this.getInventoryType();
      },
      deep: true
    },
    countryCode() {
      // Force update when country code changes
      this.$forceUpdate();
    }
  },
  created() {
    this.inventoryType = this.getInventoryType();
  },
  mounted() {
    // Named handler + beforeDestroy cleanup. This card renders once per product
    // (dozens per grid/carousel), so without $off the chancountryCode listeners
    // pile up by the hundreds as you browse — and ALL of them fire on a region
    // switch, which is what made switching QC<->ON take many seconds.
    this.$_onCountry = (countryCode) => {
      this.countryCode = countryCode;
      this.inventoryLabel();
    };
    this.$root.$on("chancountryCode", this.$_onCountry);
  },
  beforeDestroy() {
    this.$root.$off("chancountryCode", this.$_onCountry);
  },
  methods: {
    getCurrentCountryCode() {
      // Always get the latest country code from localStorage or use the data property
      return localStorage.getItem("countryCode") || this.countryCode;
    },
    getInventoryType() {
      return get(this.product, "inventory.code");
    },
    getColorCode() {
      const vm = this;
      const attributes = get(vm.product, "attributes");

      if (attributes != null) {
        const color = head(
          filter(
            attributes,
            (attribute) =>
              get(attribute, "type.code") === vm.constants.PRODUCT_COLOR
          )
        );

        if (color != null) {
          return color.code;
        }
      }
      return null;
    },
    getPastilleColor(code) {
      switch (code) {
        case this.constants.WHITE:
          return cssVariables.pastilleWhite;
        case this.constants.PALE_ORANGE:
          return cssVariables.pastilleOrangeLight;
        case this.constants.ORANGE:
          return cssVariables.pastilleOrange;
        case this.constants.RAMATO:
          return cssVariables.pastilleRamato;
        case this.constants.PINK:
          return cssVariables.pastilleRose;
        case this.constants.PALE_RED:
          return cssVariables.pastilleRedLight;
        case this.constants.RED:
          return cssVariables.pastilleRed;
        case this.constants.COLORLESS:
          return cssVariables.pastilleClear;
        case this.constants.AMBER:
          return cssVariables.pastilleAmber;
        case this.constants.BLACK:
          return cssVariables.pastilleBlack;
        default:
          return cssVariables.pastilleClear;
      }
    },

    inventoryLabel() {
      const isOntario = this.countryCode === "ON" || localStorage.getItem("countryCode") === "ON";

      this.inventoryClass = isOntario ? "ontario" : "quebec";

      const inventoryMapping = isOntario
        ? {
          IP: "CSMT",
          SAQ: "LCBO",
          LCBO: "LCBO",
          STORE_TORONTO: "DIR",
          MERCH_TORONTO: 'DIR',
          PI: "DIR",
          Consignment: "PRI",
          null: "CSMT",
        }
        : {
          Réseau: "Réseau",
          IP: "IP",
          SAQ: "SAQ",
          STORE_MTL: "DIR",
          Brouhh : "DIR",
          MERCH_MTL: 'DIR',
          BERGEVILLE: 'DIR',
          // null: "",
        };

      return inventoryMapping[this.inventoryType] || "";
    },
}
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";
$carousel-image-size: 356px;
$carousel-image-size-mobile: 350px;

.el-card {
  border-radius: 0px;
  border: 0;
  background-color: $color-background-area1;
  color: #333333;
  line-height: normal;
  margin: auto;
}
.product-background {
  border: 0 solid rgba(237, 240, 237, 0.33);
  background-color: rgba(237, 240, 237, 0.33);
}
.product__detail {
  margin-top: 10px;
  height: 152px;

  & div {
    background-color: rgba(255, 255, 255, 0);
    color: rgba(39, 36, 33, 0.7);
    box-sizing: border-box;
    text-align: left;
    line-height: normal;
    font-weight: 300;
    letter-spacing: 0.25px;
  }
}
.product__name {
  color: $color-on-background !important;
  // font-family: 'FuturaStd-Medium', 'Futura Std Medium', 'Futura Std', sans-serif;
  min-height: 20px;
  font-weight: 300;
  font-size: 16px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.product__price {
  color: #272421 !important;
  margin-bottom: 39px;
  margin-right: 30px;
  margin-top: 5px;
  font-family: $font-family-futura-std;
  @media screen and (max-width: $media-md) {
    margin-right: 0px;
  }
}
.product__volume {
  color: #272421 !important;
  margin-top: 10px;
  margin-bottom: 39px;
  font-family: $font-family-futura-std;
}
.carousel__height {
  // sm -
  @media screen and (max-width: $media-md) {
    height: $carousel-image-size-mobile;
  }
  // md
  @media screen and (min-width: $media-md) and (max-width: $media-lg) {
    height: $carousel-image-size-mobile;
  }
  // lg +
  @media screen and (min-width: $media-lg) {
    height: $carousel-image-size;
  }
}
.carousel__width {
  // sm -
  @media screen and (max-width: $media-md) {
    // width: $carousel-image-size-mobile;
    width: 100%;
  }
  // md
  @media screen and (min-width: $media-md) and (max-width: $media-lg) {
    // width: $carousel-image-size-mobile;
    width: 95%;
  }
  // lg +
  @media screen and (min-width: $media-lg) {
    // width: $carousel-image-size;
  }
}
// .image-container {
//   position: relative;
// }
.circle {
  width: 12px;
  height: 12px;
  -webkit-border-radius: 12px;
  -moz-border-radius: 12px;
  border-radius: 12px;
  background: red;
  margin-left: 5px;
}
.circle--position {
  bottom: 5px;
  right: 28px;
}
.quebec {
  .inventory__label {
    padding-top: 1px !important;
    order: 2;
    display: flex;
    bottom: 3px;
    right: 4px;
    // height: 16px;
    width: fit-content;
    justify-content: center;
    line-height: normal;
    padding: 0px 5px;
  }
  // .inventory__saq {
  //   position: absolute;
  //   bottom: 3px;
  //   right: 10px;
  //   // height: 16px;
  //   width: 35px;
  //   justify-content: center;
  //   line-height: 1;
  // }
}
.ontario {
  .inventory__label {
    order: 2;
    bottom: 3px;
    right: 10px;
    height: 16px;
    width: fit-content;
    line-height: normal;
    padding: 0px 5px;
  }
  // .inventory__saq {
  //   position: absolute;
  //   bottom: 3px;
  //   right: 10px;
  //   height: 16px;
  //   width: 41px;
  // }
}

.inventory {
  border-radius: 2px;
  border: 1px solid rgba(39, 36, 33, 0.33);
  box-sizing: border-box;
  font-family: "Futura Std ", "Futura Std", sans-serif;
  font-weight: 700;
  color: rgba(39, 36, 33, 0.33);
  text-align: center;
  line-height: normal;
  letter-spacing: 0.4px;
  font-size: 12px;
  color: #fff;
  background-color: #b4b3b2;
  border: 0;
  padding-top: 2px;
}
.quebec {
  .circle--position-display {
    bottom: 4px;
    right: 35px;
  }
}
.ontario {
  .circle--position-display {
    bottom: 4px;
    right: 55px;
  }
}

.product-background {
  img {
    transform: scale(1);
    transition: transform 0.2s ease-in-out;
    object-fit: contain;
  }
}
.product-background {
  &:hover {
    img {
      transform: scale(1.1);
    }
  }
}
.producer_name {
  height: 20px;
  font-size: 14px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.disponible-label {
  font-family: "Futura Std ", "Futura Std", sans-serif;
  color: #272421;
  line-height: normal;
  letter-spacing: 0.4px;
}
.couleur-disponible {
  width: 8px;
  height: 8px;
  background-color: #70b603;
}
.couleur-non-disponible {
  width: 8px;
  height: 8px;
  background-color: $color-primary;
}
.product-availability-label {
  margin-top: -1px;
  font-size: 9px !important;
}
@media screen and (max-width: 450px) {
  .circle--position-display {
    right: 50px !important;
  }
  .inventory {
    right: 15px !important;
  }
  .ontario {
    .circle--position-display {
      right: 59px !important;
    }
    .inventory {
      right: 25px !important;
      font-size: 9px;
      height: 15px;
      width: 32px;
    }
  }
}
@media screen and (max-width: 360px) {
  .thumbnail__dimension {
    width: 100%;
    height: 150px;
    .disponible-label {
      right: 15px !important;
    }
    .inventory__label {
      right: 10px !important;
    }
    .circle--position-display {
      right: 35px !important;
    }
  }
}
.highlight {
  height: 11px;
}
.origin__detail {
  height: 16px;
}
</style>
